// extracted by mini-css-extract-plugin
export default {"dialogHeading":"RemoveVehicleDialog_dialogHeading__S6UKt","actionWrapper":"RemoveVehicleDialog_actionWrapper__OMVTW"};